<div class="thumbnail-wrapper {{border}}" [ngStyle]="{width: size + measure, height: size + measure}">
  <div class="thumbnail">
    <img
      [src]="user | photoOrDefault: activeMenu"
      (error)="onImgError($event)"
      alt="user profile photo"
      class="thumbnail-img"
      />
  </div>
</div>
